import TextField from '@material-ui/core/TextField';

const TimeTextField = ({ ...rest }) => {
  return <TextField type="time" {...rest} />;
};

export default TimeTextField;
